export const SKELETON_SHOW_DELAY_MS = 300;
export const SKELETON_MIN_VISIBLE_MS = 400;
export const SKELETON_FADE_MS = 200;
export const SKELETON_PULSE_MS = 1600;

export function getSkeletonHoldMs(shownForMs: number): number {
    return Math.max(0, SKELETON_MIN_VISIBLE_MS - shownForMs);
}

export function getPulseDelayMs(nowMs: number): number {
    return -(nowMs % SKELETON_PULSE_MS);
}
